var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoProfilePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40 0c22.091 0 40 17.909 40 40S62.091 80 40 80 0 62.091 0 40 17.909 0 40 0z",
    id: "pcjb1h4jfa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "go9qzzkstb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pcjb1h4jfa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EEECF2",
    xlinkHref: "#pcjb1h4jfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.256 55.865c-1.447-.24-1.48-4.367-1.48-4.367s4.254-4.367 5.18-10.24c2.495 0 4.035-6.243 1.54-8.44.105-2.312 3.206-18.151-12.496-18.151-15.703 0-12.6 15.839-12.497 18.151-2.494 2.197-.954 8.44 1.54 8.44.927 5.873 5.181 10.24 5.181 10.24s-.033 4.128-1.48 4.367c-4.664.77-22.077 8.734-22.077 17.468L40 94l29.333-20.667c0-8.734-17.413-16.699-22.077-17.468z",
    fill: "#C8C5CD",
    fillRule: "nonzero",
    mask: "url(#go9qzzkstb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoProfilePlaceholder);
export default __webpack_public_path__ + "static/media/ic_photo_profile_placeholder.84abe60577c6dd3737c63ef6489e23c0.svg";
export { ForwardRef as ReactComponent };